import { ReactNode } from 'react';
import BaseNode from './BaseNode';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { colors } from '../../styles';

const VARIANTS: Record<string, { typeLabel: string; icon: ReactNode }> = {
  MICROSOFT_READ_EXCEL: { typeLabel: 'Microsoft · Excel', icon: <TableChartOutlinedIcon /> },
  MICROSOFT_READ_EXCEL_V2: { typeLabel: 'Microsoft · Excel', icon: <TableChartOutlinedIcon /> },
  MICROSOFT_UPLOAD_FILE: { typeLabel: 'Microsoft · Upload', icon: <CloudUploadOutlinedIcon /> },
};

const MicrosoftNode = ({ data }: { data: { label: string; variant?: string } }) => {
  const variant = (data.variant && VARIANTS[data.variant]) || { typeLabel: 'Microsoft', icon: <CloudOutlinedIcon /> };
  return (
    <BaseNode label={data.label} typeLabel={variant.typeLabel} accent={colors.chart.integration} icon={variant.icon} />
  );
};

export default MicrosoftNode;
